export default {
  Confirm: 'Carregar',
  Cancel: 'Cancelar',
  'The minimum time length is xxxs!': 'A duração mínima é {{num}}s!',
  'The maximum time length is 50s!': 'A duração máxima é 50s!',
  'Online service, no download required': 'Editar online, sem necessidade de download',
  'Add up to 20MB file': 'Adicionar até 20MB de arquivo',
  'Support common formats': 'Suportar formatos comuns',
  'Best for general editing requirements': 'Resolução para suas necessidades de edição diária',
  '0 second wait': '0 segundo de espera',
  'No size limits': 'Sem limites de tamanho',
  'Support 1000+ formats': 'Suportar 1000+ de formatos',
  'Stable processing': 'Processamento estável',
  'Get access to HitPaw Toolkit!': 'Obtenha acesso ao HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Suportar cortar, recortar & girar, ajustar, acelerar, adicionar música, stop motion, etc.',
  'The easiest video editing software for beginners':
    'O software de edição de vídeo mais fácil para iniciantes',
  'Remove watermark from videos and images in simple clicks':
    "Remover a marca d'água de vídeos e de imagens em cliques simples",
  'TRY IT FREE': 'Obtenha Grátis Agora',
  'BUY NOW': 'Compra Agora',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Análise feita com sucesso! Seu arquivo tem mais de 100 MB e não pode ser editado pelo HitPaw Online, ',
  'download the video': 'baixe o vídeo',
  'and then use HitPaw Toolkit to proceed.': ' e use o HitPaw Toolkit para prosseguir.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Cortar 10 clips de vídeo no máximo. Obtenha o HitPaw Toolkit para mais recursos.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'O tamanho do arquivo não pode ser maior do que 20MB. Obtenha o HitPaw Toolkit para mais recursos.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'A duração mínima é 1s! Obtenha o HitPaw Toolkit para mais recursos.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Adicione no máximo 3 vídeos. Obtenha o HitPaw Toolkit para mais recursos.',
  'This format is not supported currently.': 'Este formato não é suportado atualmente.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Este formato não é suportado atualmente. Obtenha o HitPaw Toolkit para mais recursos.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Falha ao Gerar Vídeo!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Falha ao carregar!',
  'Are you sure you want to delete it?': 'Tem certeza que deseja deletar?',
  'Failed to extract the audio!': 'Falha ao extrair o áudio!',
  'Coming Soon': 'Em breve',
  'Learn more': 'Saiba mais',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Adicionar no máximo 2 arquivos. Obtenha o HitPaw Toolkit para mais recursos.',
  Download: 'Baixar',
  'Try Again': 'Tentar novamente',
  Failed: 'Falhou',
  'Get Started': 'Começar a Editar',
  Start: 'Início',
  End: 'Fim',
  Export: 'Exportar',
  'Your audio is ready!': 'Seu áudio está pronto!',
  'Download Audio': 'Baixar o Áudio',
  YES: 'Sim',
  'Export Failed': 'Falha em Exportar',
  'Error occurs, the file cannot be added': 'Ocorre um erro, o arquivo não pode ser adicionado',
  'Support merging audio files at most': 'Apoiar a fusão de {{num}} arquivos de áudio no máximo',
  'Are you sure you want to delete this task?': 'Você tem certeza de que quer apagar esta tarefa?',
  Processing: 'Processando',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Não se esqueça de baixar seu arquivo, ele será apagado 24 horas depois.',
  Uploading: 'Carregando',
  'Go Edit': 'Editar',
  'Generate Files Successfully!': 'Gerar Arquivos com Sucesso!',
  'Your order is being paid...': 'Você já pagou pelo seu pedido?',
  'Not yet': 'Ainda não',
  'Payment completed': 'Sim',
  downloadFail: 'Falha ao baixar, tente novamente.',
  videoReady: 'Sua foto animada está pronta!',
  'Download Without Watermark': "Baixe sem marca d'água",
  'Download As GIF': 'Baixar como GIF',
  'Download With Watermark': "Faça o download com a marca d'água",
  'Upload New Photo': 'Carregue uma nova foto',
  'Upgrade to access HitPaw Online Pro Features.':
    'Atualize para acessar os recursos do Hitpaw Online Pro.',
  'Free account cannot upload image size that exceeds 2M.':
    'A conta gratuita não pode fazer upload do tamanho da imagem que excede 2M.',
  'Free account cannot upload more than 6 images.':
    'A conta gratuita não pode fazer upload de mais de 6 imagens.',
  'No Image Size Limits': 'Sem limites de tamanho de imagem',
  'Unlimited Image Uploads': 'Uploads de imagem ilimitados',
  'Download HD Image with No Watermark': "Baixe a imagem HD sem marca d'água",
  'Download Video as GIF': 'Baixe o vídeo como GIF',
  'More Privileges': 'Mais privilégios',
  Monthly: 'Por mês',
  Yearly: 'Anual',
  'Cancel auto-renewable subscription anytime.':
    'Cancelar assinatura automática renovável a qualquer momento.',
  'Login to Start': 'Faça login para começar',
  'Buy Now': 'Comprar agora',
  'Network Error': 'Erro de rede',
  'Connection server failed.': 'Falha no servidor de conexão.',
  Month: 'Mês',
  priceMonth: 'US $ 9.99',
  priceYear: 'US $ 4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'O tamanho do vídeo carregado não pode exceder 20 MB. Faça o download do HitPaw Video Converter para obter mais recursos.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'O tamanho do vídeo carregado não pode exceder 500 MB. Faça o download do HitPaw Video Converter para obter mais recursos.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'A resolução da imagem carregada não pode exceder 16 megapixels. Faça o download do HitPaw Video Converter para obter mais recursos.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'A função de processamento em lote está disponível apenas no software de desktop. Faça o download do HitPaw Video Converter para obter mais recursos.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'O número de arquivos que você processou hoje atingiu o limite superior de 300. Faça o download do Hitpaw Video Converter para obter mais recursos.',
  'Download desktop version to batch process large files with no size limit': 'Baixar a versão para desktop para processar arquivos grandes em lote sem limite de tamanho',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Converter arquivos de vídeo e áudio em lote para mais de 1000 formatos com velocidade 120X mais rápida',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Baixar e salvar vídeos de mais de 10.000 sites, como YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': `Recursos avançados de edição de vídeo integrados: combinar, cortar, recortar, adicionar marca d'água etc.`,
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Converter o Apple Music para MP3 com o DRM removido (somente na versão Windows)',
}
